export const BILLING_REQUIRED_EVENT = 'billing-required';

export interface BillingRequiredEventDetail {
  message?: string;
}
